import { render, staticRenderFns } from "./ActivityPageTwo.vue?vue&type=template&id=18e356a9&scoped=true&"
import script from "./ActivityPageTwo.vue?vue&type=script&lang=js&"
export * from "./ActivityPageTwo.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPageTwo.vue?vue&type=style&index=0&id=18e356a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e356a9",
  null
  
)

export default component.exports